import { validateGridSearch } from "@/components/composite/data-grid";
import { ProtectedPage } from "@/components/misc/protected";
import { createFileRoute } from "@tanstack/react-router";
import { ExperimentsPage } from "./-index/experiments.page";

export const Route = createFileRoute("/experiments/")({
  validateSearch: validateGridSearch,
  component: () => (
    <ProtectedPage requires="org:experiment_v2:experiment_v2_read">
      <ExperimentsPage />
    </ProtectedPage>
  ),
});
